import api from "lib/axios";
import { ApiEnvelope, PaginatedResult, unwrapData, unwrapList, unwrapResult } from "./apiTypes";

type Query = Record<string, unknown> | undefined;
type Payload = Record<string, unknown>;

export const roleService = {
  async listPermissions() {
    const response = await api.get<ApiEnvelope<any>>("/mcp/permissions", {
      meta: { toastSuccess: false },
    });
    return unwrapResult(response.data);
  },
  async listRoles(params?: Query) {
    const response = await api.get<ApiEnvelope<PaginatedResult<any>>>("/mcp/roles", {
      params,
      meta: { toastSuccess: false },
    });
    return unwrapList(response.data);
  },
  async showRole(id: number | string) {
    const response = await api.get<ApiEnvelope<{ data: any }>>(`/mcp/roles/${id}`, {
      meta: { toastSuccess: false },
    });
    return unwrapData(response.data);
  },
  async createRole(data: Payload) {
    const response = await api.post<ApiEnvelope<{ data: any }>>("/mcp/roles", data);
    return unwrapData(response.data);
  },
  async updateRole(id: number | string, data: Payload) {
    const response = await api.put<ApiEnvelope<{ data: any }>>(`/mcp/roles/${id}`, data);
    return unwrapData(response.data);
  },
  async deleteRole(id: number | string) {
    const response = await api.delete(`/mcp/roles/${id}`);
    return response.data;
  },
};

